import React from 'react';
import { Grid } from '@mui/material';
import Tile from 'components/Tile/Tile';
import makeStyles from '@mui/styles/makeStyles';
import 'assets/scss/score-card.scss';
import _, { isEmpty } from 'lodash';

/* Statuses: 
    - reviewRequired - orange - #ffa233
    - preApproved - green - #36b37e
    - declined - red - #ff5630
*/

const styles = {
  right: {
    textAlign: 'right' as const,
  },
  greenButton: {
    margin: 0,
    float: 'right' as const,
  },

  fullWidth: {
    width: '100%',
  },
  preApproved: {
    color: '#36b37e',
  },
  reviewRequired: {
    color: '#ffa233',
  },
  declined: {
    color: '#ff5630',
  },
  defaultStatus: {
    color: '#36b37e',
  },
};

const useStyles = makeStyles(styles);

const getStatusClass = (status: string) => {
  switch (status) {
    case 'Pre-Approved':
      return 'preApproved';
    case 'Review Required':
      return 'reviewRequired';
    case 'Declined':
      return 'declined';
    default:
      return 'defaultStatus';
  }
};

export const ScoreCardFastTrack = ({ vo }: any) => {
  const classes = useStyles();
  let inputs: { key: string; value: string }[] = vo ? vo.fastTrackResults[0]?.inputs : [];
  let outputs: { key: string; value: string }[] = vo ? vo.fastTrackResults[0]?.outputs : [];

  let scoreCardStatus = 'Awaiting Review'; // Default ScoreCard status

  if (outputs && outputs?.find((output: { key: string; value: string }) => output?.key === 'Decision')?.value) {
    scoreCardStatus = outputs.find((output: { key: string; value: string }) => output?.key === 'Decision')?.value!;
  }

  if (_.some([inputs, outputs], isEmpty)) {
    return null;
  }

  return (
    <div>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Tile title="Scorecard" useCollapsing={true} className="score-card__main-title">
            <Grid>
              <Grid container className="score-card__decision-wrapper">
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <span className="score-card__decision-text">Decision:</span>
                  <span className={`score-card__decision-status ${classes[getStatusClass(scoreCardStatus)]}`}>
                    {scoreCardStatus}
                  </span>
                </Grid>
              </Grid>

              <Grid container className="score-card__decisioning-variables">
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <div className="score-card__decisioning-title">Decisioning Variables</div>
                </Grid>
              </Grid>
              <>
                <Grid item container className="score-card__decisioning-content">
                  <Grid item xs={6} sm={6} md={6} lg={6} xl={6} container className="score-card__decisioning-left">
                    <div className="score-card__decisioning-input-text">Inputs:</div>
                    <div className="score-card__decisioning-input-value">
                      {inputs &&
                        inputs.map(item => {
                          return (
                            <div className="score-card__decisioning-input-item">
                              <div className="score-card__input-item-left">{item.key}:</div>
                              <div className="score-card__input-item-right">{item.value}</div>
                            </div>
                          );
                        })}
                    </div>
                  </Grid>
                  <Grid item xs={6} sm={6} md={6} lg={6} xl={6} container className="score-card__decisioning-right">
                    <div className="score-card__decisioning-output-text">Outputs:</div>
                    <div className="score-card__decisioning-output-value">
                      {outputs &&
                        outputs.map(item => {
                          return (
                            <div className="score-card__decisioning-input-item">
                              <div className="score-card__input-item-left">{item.key}:</div>
                              <div className="score-card__input-item-right">{item.value}</div>
                            </div>
                          );
                        })}
                    </div>
                  </Grid>
                </Grid>
              </>
            </Grid>
          </Tile>
        </Grid>
      </Grid>
    </div>
  );
};
